import { __decorate, __metadata, __param } from "tslib";
import { Symbols } from '@/symbols';
import { inject, injectable } from 'inversify';
let ApiAnalysisService = class ApiAnalysisService {
    constructor(api) {
        this.api = api;
    }
    getCompanyPackages(id) {
        return this.api.getCompanyPackages(id);
    }
    getMonthlyBill(data) {
        return this.api.getMonthlyBill(data);
    }
    getPackageUsage(data) {
        return this.api.getPackageUsage(data);
    }
    downloadExcelExport(data) {
        return this.api.downloadExcelExport(data);
    }
    getCustomerRanking(data) {
        return this.api.getCustomerRanking(data);
    }
    getCompanyList() {
        return this.api.getCompanyList();
    }
    getPackageRanking(data) {
        return this.api.getPackageRanking(data);
    }
    getAPIRanking(data) {
        return this.api.getAPIRanking(data);
    }
    getConfigList(data) {
        return this.api.getConfigList(data);
    }
    saveConfig(data) {
        return this.api.saveConfig(data);
    }
    configUpload(data) {
        return this.api.configUpload(data);
    }
    deleteConfig(id, type) {
        return this.api.deleteConfig(id, type);
    }
    publishConfig() {
        return this.api.release();
    }
    addSolutionGroup(data) {
        return this.api.addSolutionGroup(data);
    }
    deleteSolutionGroup(params) {
        return this.api.deleteSolutionGroup(params);
    }
    getSolutionGroup() {
        return this.api.getSolutionGroup();
    }
};
ApiAnalysisService = __decorate([
    injectable(),
    __param(0, inject(Symbols.OpenApi)),
    __metadata("design:paramtypes", [Object])
], ApiAnalysisService);
export { ApiAnalysisService };
